"use strict";

import fixed from "./header.fixed";
import overview from "./header.overview";
import scrollLine from "./header.scrollLine";
import searchBar from "./header.searchBar";
import mobile from "./header.mobile";
import anchor from "./header.anchor";

export default {
    fixed,
    overview,
    scrollLine,
    searchBar,
    mobile,
    anchor,
};
